import { GET_ZONA_DETALLE, MODIFY_ZONA_TIPO_PARTIDA, ADD_ZONA_TIPO_PARTIDA, DELETE_ZONA_TIPO_PARTIDA } from '../constants/action_types';

const initialState = {
    isLoading: true,
    tiposPartida: []
};

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_ZONA_DETALLE + "_SUCCESS":

            return {
                isLoading: false,
                tiposPartida: action.payload.data.tipoPartidas
            };

        case ADD_ZONA_TIPO_PARTIDA:

            const newArr = [...state.tiposPartida, action.payload]

            return {
                isLoading: false,
                tiposPartida: newArr,
            };

        case MODIFY_ZONA_TIPO_PARTIDA:

            return {
                isLoading: false,
                tiposPartida: state.tiposPartida.map((tiposPartida) => {
                    if (tiposPartida.id !== action.payload.id) return tiposPartida;
                    else return action.payload;
                }),
            };


        case DELETE_ZONA_TIPO_PARTIDA:

            return {
                isLoading: false,
                tiposPartida: state.tiposPartida.filter(tiposPartida => tiposPartida.id !== action.payload.id),
            };

        default:

            return state;
    }

}